import { FILTER_PREFIX } from '@/constants';
import { getKeyWidthPrefix } from '@/utils';
import { FilterTypes } from '@servicepipe/ui-components';

import { groupRoleSelectOptions } from '../store';

type QueryFilter = {
  id: string;
  value?: string;
};

type FilterConfig = {
  id: number;
  name: string;
  label: string;
  type: (typeof FilterTypes)[keyof typeof FilterTypes];
  value: string;
  width: string;
  options?: Array<{ value: string; label: string }>;
};

export const usersFiltersConfig: FilterConfig[] = [
  {
    id: 1,
    name: 'id',
    label: 'ID',
    type: FilterTypes.INPUT,
    value: '',
    width: '120px',
  },
  {
    id: 2,
    name: 'email',
    label: 'Email',
    type: FilterTypes.INPUT,
    value: '',
    width: '220px',
  },
];

export const administratorsFiltersConfig: FilterConfig[] = [
  {
    id: 1,
    name: 'partnerClientAccountEmployee',
    label: 'Email',
    type: FilterTypes.INPUT,
    value: '',
    width: '240px',
  },
];

export const accessGroupsFiltersConfig: FilterConfig[] = [
  {
    id: 1,
    name: 'id',
    label: 'ID',
    type: FilterTypes.INPUT,
    value: '',
    width: '120px',
  },
  {
    id: 2,
    name: 'name',
    label: 'Group name',
    type: FilterTypes.INPUT,
    value: '',
    width: '200px',
  },
  {
    id: 3,
    name: 'role',
    label: 'Role',
    type: FilterTypes.SELECT,
    value: '',
    width: '180px',
    options: groupRoleSelectOptions,
  },
];

export const resourceNameFiltersConfig: FilterConfig[] = [
  {
    id: 1,
    name: 'resourceName',
    label: 'Resource name',
    type: FilterTypes.INPUT,
    value: '',
    width: '250px',
  },
];

export const accessGroupUsersFiltersConfig: FilterConfig[] = [
  {
    id: 1,
    name: 'userEmail',
    label: 'Email',
    type: FilterTypes.INPUT,
    value: '',
    width: '250px',
  },
];

const getFilterValueFromQuery = (queryFilters: QueryFilter[], columnId: string): string => {
  const filterKey = getKeyWidthPrefix(columnId, FILTER_PREFIX);

  return queryFilters.find((filter) => filter.id === filterKey)?.value ?? '';
};

export const mergeFiltersWithQueryParams = (
  filtersConfig: FilterConfig[],
  queryFilters: QueryFilter[]
): FilterConfig[] =>
  filtersConfig.map((filter) => ({
    ...filter,
    value: getFilterValueFromQuery(queryFilters, filter.name),
  }));

export const filtersListToColumnFiltersState = (filtersList: FilterConfig[]) =>
  filtersList.map((filter) => ({
    id: filter.name,
    value: filter.value || '',
  }));
